define('app/views/busca',['require','backbone','twig','text!../tpl/busca.twig','../collections/posicoes','../collections/tipos','../models/busca'],function(require){

	var Backbone = require('backbone');
	var Twig = require('twig');
	var tpl = require('text!../tpl/busca.twig');
	var template = Twig.twig({data:tpl});

	

    var posicoes = require('../collections/posicoes');
	var tipos = require('../collections/tipos');
	var busca = require('../models/busca');


	var view = Backbone.View.extend({
		initialize: function(config) {
			var that = this;
			
			
			
			that.data = {
				
			}
			
			that.listenTo(posicoes,'all',that.render);
			that.listenTo(tipos,'all',that.render);
			that.listenTo(busca,'all',that.render);


			that.render();
			
		},
		events: {
			'change .posicao': 'setPosicoes',
			'change .tipo': 'setTipos',
			'change .flags': 'changeFlags',
			'submit': 'onSubmit'
		},
		onSubmit: function(e) {
			var that = this;
			var $that = $(e.currentTarget);
			
			busca.set({
				referencia: that.$el.find('[name=referencia]').val()
			});
			
			return false;
		},
		changeFlags: function(e) {
			var that = this;
			var $that = $(e.currentTarget);
			
			var name = $that.attr('name');
			busca.set(name,$that.is(':checked')?true:false);
		},
		setPosicoes: function(e) {
			var that = this;
			var $that = $(e.currentTarget);
			
			var posicao_id = $that.val()|0;
			
			posicoes.get(posicao_id).set({				
				checked: $that.is(':checked')?true:false
			});
				
		},
		setTipos: function(e) {
			var that = this;
			var $that = $(e.currentTarget);
			
			var tipo_id = $that.val()|0;
			
			tipos.get(tipo_id).set({				
				checked: $that.is(':checked')?true:false
			});
				
		},
		render: function() {
			var that = this;
			
			

			var data = $.extend({},that.data);
			
			data.posicoes = posicoes.toJSON();
			data.tipos = tipos.toJSON();
			data.busca = busca.toJSON();
			
			

			that.$el.html(template.render(data));
			return that;
		}
	});

	return view;
});
